import { TextInputComponent } from "components";
import { useFormProvider } from "../../../../providers";

export function NameComponent() {
  const { name } = useFormProvider();

  return <TextInputComponent label="Nama Pengirim" value={name} disabled />;
}
